<template>
  <div>
    <div>
      <i
        class="fas fa-flag"
        :style="'color: ' + params.value"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'PriorityColorIcons'
})

</script>

<style>
    .flag-size {
        width: 15px;
    }
</style>
